module.exports = __webpack_public_path__ + "img/Slide32.1c58b4aa.png";